import React from 'react'
import styles from './customSwitch.module.scss'
import { useMobileViewport } from '../../../../../util/mobileViewPort';

const CustomSwitch = (props) => {
  const { onClickHandler, state } = props;
  const isMobile = useMobileViewport();
  return (
    <div onClick={(event) => {
      event.stopPropagation();
      onClickHandler();
    }}
      className={`${styles.custom__switch__base} ${state ? styles.active : ''}`}>
      <div className={`${styles.custom__switch__circle} ${state ? styles.active : ''}`}></div>
    </div>
  )
}

export default CustomSwitch